import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedParkourBasedPrice: { line: {}, parkourBasedPricingDetails: [{ fromStation: {}, toStation: {} }] },
    parkourBasedPrices: [],
  }),

  mutations: {
    setSelectedParkourBasedPrice(state, parkourBasedPrice) {
      Vue.set(state, "selectedParkourBasedPrice", parkourBasedPrice);
    },
    setParkourBasedPrices(state, parkourBasedPrices) {
      Vue.set(state, "parkourBasedPrices", parkourBasedPrices);
    },
    setParkourBasedPricingModule(state, parkourBasedPrices) {
      Vue.set(state, "selectedParkourBasedPrice", { line: {}, parkourBasedPricingDetails: [{ fromStation: {}, toStation: {} }] });
      Vue.set(state, "parkourBasedPrices", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createParkourBasedPrice: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/parkour-based-pricing/entity", request, {})
        .then((response) => {
          context.commit("setParkourBasedPrices", response.data);
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadParkourBasedPrices: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadParkourBasedPrice: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/entity/" + request.id, {}).then((response) => {
        context.commit("setSelectedParkourBasedPrice", response.data);
        return response.data;
      });
    },

    loadPublishedParkourBasedPrices: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/entity/published").then((response) => {
        return response.data;
      });
    },

    updateParkourBasedPrice: (context, request) => {
      return axios.put(context.getters.getMcServiceUrl + "/parkour-based-pricing/entity", request, {}).then((response) => {
        return response.data;
      });
    },
    deleteParkourBasedPrice: (context, parkourBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/parkour-based-pricing/entity/" + parkourBasedPrice.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          parkourBasedPrice.intents = intents;
          parkourBasedPrice.intentId = response.data.id;
          return parkourBasedPrice;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftParkourBasedPrice: (context, parkourBasedPrice) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/parkour-based-pricing/draft/" + parkourBasedPrice.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishParkourBasedPrice: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    loadSelectedParkourBasedPriceHistory: (context, parkourBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/history/" + parkourBasedPrice.id, {}).then((response) => {
        return response.data;
      });
    },

    rejectParkourBasedPrice: (context, parkourBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/reject/" + parkourBasedPrice.intentId).then((response) => {
        if (parkourBasedPrice.intents[0].type === "DELETE_PARKOUR_BASED_PRICING") {
          parkourBasedPrice.intents = null;
          parkourBasedPrice.intentId = 0;
        } else if (parkourBasedPrice.intents[0].type === "CREATE_PARKOUR_BASED_PRICING") {
          parkourBasedPrice.intents[0].status = "DRAFT";
        } else if (parkourBasedPrice.intents[0].type === "UPDATE_PARKOUR_BASED_PRICING") {
          parkourBasedPrice.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallParkourBasedPrice: (context, parkourBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/recall/" + parkourBasedPrice.intentId).then((response) => {
        //TODO:Name should starting with letter.
        helper.recallOrRejectEntity(parkourBasedPrice, "PARKOUR_BASED_PRICING");
        return response.data;
      });
    },

    cancelParkourBasedPrice: (context, parkourBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/cancel/" + parkourBasedPrice.intentId).then((response) => {
        return response.data;
      });
    },

    sendToApprovalParkourBasedPrice: (context, parkourBasedPrice) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricing/sendToApproval/" + parkourBasedPrice.intentId).then((response) => {
        if (parkourBasedPrice.intents[0].type === "CREATE_PARKOUR_BASED_PRICING") {
          parkourBasedPrice.intents[0].status = "WAITING_APPROVAL";
        } else if (parkourBasedPrice.intents[0].type === "UPDATE_PARKOUR_BASED_PRICING") {
          parkourBasedPrice.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
  },
  getters: {
    getSelectedParkourBasedPrice: (state) => {
      return state.selectedParkourBasedPrice;
    },
    getParkourBasedPrices: (state) => {
      return state.parkourBasedPrices;
    },
    getPublishedParkourBasedPrices: (state) => {
      return state.parkourBasedPrices.filter((entity) => {
        return entity.intentId === 0;
      });
    },
  },
};
